/** @format */

import axios from "axios";
import {
  REQUEST_HEADER_AUTH_KEY,
  REQUEST_HEADER_COOKIES,
  TOKEN_TYPE,
} from "src/constant/api.constant.ts";
import { PERSIST_STORE_NAME } from "src/constant/app.constant";
import deepParseJson from "src/utilities/deepParseJson";
import store from "../store";
import { signOutSuccess } from "../store";

const unauthorizedCode = [401];

const BaseService = axios.create({
  timeout: 60000,
  baseURL: "https://firstlinks-api.first-cert.com/", //appConfig.apiPrefix,
  withCredentials: true,
});

BaseService.interceptors.request.use(
  (config) => {
    const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME);
    const persistData = deepParseJson(rawPersistData);

    let accessToken = persistData.auth?.token;

    if (!accessToken) {
      const { auth } = store.getState();
      accessToken = auth.token;
    }

    if (accessToken) {
      config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

BaseService.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (response && unauthorizedCode.includes(response.status)) {
      store.dispatch(signOutSuccess());
    }

    return Promise.reject(error);
  }
);

export default BaseService;
